import React from 'react'

export const GlobalContext: any = React.createContext({
});